import { MetaradarRefreshState, MetaradarRefreshStatus } from '@app/model/metaradar/MetaradarRefreshStatus';

// 'unknown': the status no longer describes the watched request (a later refresh, or the end of its cooldown), so the
// watch stops without a toast.
export type MetaradarRefreshEnd = 'success' | 'failure' | 'unknown';

/**
 * How the watched Metaradar refresh of a hotel ended, or undefined while it still runs (ROO2-232). With no request id
 * yet (the status of a refresh can come before its execution details), the refresh that ends is the watched one.
 */
export const metaradarRefreshEnd = (
	status: Pick<MetaradarRefreshStatus, 'status' | 'executionState'> | undefined,
	requestId: number | undefined,
): MetaradarRefreshEnd | undefined => {
	if (!status) return undefined;
	const execution = status.executionState;
	if (requestId === undefined) {
		if (status.status === MetaradarRefreshState.IN_PROGRESS) return undefined;
		if (execution?.isFinished === true) return execution.isSuccessful ? 'success' : 'failure';
		return 'unknown';
	}
	if (execution?.requestId === requestId) {
		if (!execution.isFinished) return undefined;
		return execution.isSuccessful ? 'success' : 'failure';
	}
	if (!execution && status.status === MetaradarRefreshState.IN_PROGRESS) return undefined;
	return 'unknown';
};

/**
 * The text of the toast at the end of a refresh, with the hotel name.
 */
export const metaradarRefreshMessage = (end: 'success' | 'failure', hotelName?: string): string => {
	const trimmed = hotelName?.trim() ?? '';
	const name = trimmed !== '' ? trimmed : 'this hotel';
	return end === 'success'
		? `Metaradar refreshed for ${name}.`
		: `Metaradar could not refresh ${name}. Please try again later.`;
};
